import { render, staticRenderFns } from "./TimelineWidget.vue?vue&type=template&id=3a4d309c&"
import script from "./TimelineWidget.vue?vue&type=script&lang=js&"
export * from "./TimelineWidget.vue?vue&type=script&lang=js&"
import style0 from "./TimelineWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports